import { initMainReact } from "./main-react";
import { initMySavedColors } from "./my-saved-colors";
import { initDeleteAccount } from "./delete-account";
import { initMyStyle } from "./my-style";
import { initProfileImage } from "./profile-image";
import { initSaveColor } from "./save-color";
import { initColorCollections } from "./color-collections";
import { initSaveSingleColor } from "./save-single-color";
import { initEditColorCollections } from "./edit-color-collections";
import { initAddSavedColorsToCollection } from "./add-saved-colors-to-collection";
import { initFollowMember } from "./follow-member";
import { initAddColorToCollection } from "./add-color-to-collection";
import { initAllActivityFeed } from "./all-activity-feed";
import { initRecentActivityFeed } from "./recent-activity-feed";
import { initColourPalette } from "./colour-palette";
import { initInviteFriend } from "~/react/invite-friend";

initMainReact();
initMySavedColors();
initDeleteAccount();
initMyStyle();
initProfileImage();
initSaveColor();
initColorCollections();
initSaveSingleColor();
initEditColorCollections();
initAddSavedColorsToCollection();
initFollowMember();
initAddColorToCollection();
initAllActivityFeed();
initRecentActivityFeed();
initColourPalette();
initInviteFriend();
